document.addEventListener('DOMContentLoaded', () => {
  'use strict';
  const reduce   = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasGSAP  = !!(window.gsap && window.ScrollTrigger);
  const hasAnime = !!window.anime;
  const hasLenis = !!window.Lenis;

  const head = document.getElementById('head');
  /* the header belongs to the opening slide only: it rides the first screen,
     then lifts away for good once the reader moves past it.
     Lenis swallows the native scroll event, so this rides its own callback. */
  const firstSlide = () => {
    const vh = window.innerHeight || 800;
    const main = document.getElementById('MainContent');
    const first = main && main.querySelector(':scope > .shopify-section, :scope > section, :scope > div');
    const h = first ? first.getBoundingClientRect().height : 0;
    /* on inner pages the first child is often the whole page, not an opening
       slide — in that case fall back to one screenful, so every page behaves
       the same: the header rides the first screen, then lifts away. */
    return (h > 120 && h < vh * 1.6) ? h : vh;
  };
  let slideEnd = 0;
  /* every dropdown window hangs directly under the word that opens it.
     If the word sits near an edge, the window narrows rather than slides
     away — so it always reads as belonging to that word. */
  const placeMega = () => {
    const groups = [...document.querySelectorAll('[data-mega-group]')];
    const pad = 24;
    if (window.innerWidth <= 1100) {
      groups.forEach(g => {
        const p = g.querySelector('[data-mega]');
        if (p) { p.style.removeProperty('--mega-x'); p.style.removeProperty('--mega-w'); }
      });
      return;
    }
    /* every window is the same size — the narrowest word decides it, so none
       of them has to slide off its own name to stay on screen */
    let w = 880;
    const spots = [];
    groups.forEach(group => {
      const panel = group.querySelector('[data-mega]');
      const label = group.querySelector('.nav__top');
      if (!panel || !label) return;
      const r = label.getBoundingClientRect();
      const centre = r.left + r.width / 2;
      const room = Math.min(centre - pad, window.innerWidth - pad - centre) * 2;
      w = Math.min(w, Math.max(560, room));
      spots.push({ panel, centre });
    });
    spots.forEach(({ panel, centre }) => {
      panel.style.setProperty('--mega-x', centre + 'px');
      panel.style.setProperty('--mega-w', w + 'px');
    });
  };
  addEventListener('resize', placeMega);
  addEventListener('load', placeMega);
  placeMega();

  const measure = () => {
    slideEnd = firstSlide();
    placeMega();
    /* the SHOP panel drops from exactly under the bar */
    if (head) document.documentElement.style.setProperty('--velur-head-h', head.offsetHeight + 'px');
  };
  measure();
  addEventListener('resize', measure);
  addEventListener('load', measure);
  const onHead = () => {
    if (!head) return; /* a bare page has no bar to move */
    const y = (window.scrollY || (window.lenisY || 0));
    head.classList.toggle('is-stuck', y > 40);
    /* gone once the opening slide has passed, back when she returns to it —
       but never while the menu is open: the drawer lives inside the bar,
       and the bar leaving would carry the open menu away with it */
    const navEl = document.getElementById('nav');
    const menuOpen = navEl && navEl.classList.contains('open');
    head.classList.toggle('head-away', !menuOpen && y > (slideEnd - head.offsetHeight - 10));
  };
  addEventListener('scroll', onHead, { passive:true }); onHead();


  /* mobile nav — bound inline in sections/header.liquid, the moment the bar
     is parsed, so the button answers before these libraries have arrived */

  /* Into the Air — hover a ritual name, its image fills the stage */
  (() => {
    const stage = document.getElementById('airStage');
    const items = [...document.querySelectorAll('.air2__item')];
    if (!items.length) return;
    const setActive = (it) => {
      items.forEach(i => i.classList.toggle('is-active', i === it));
      if (stage && it.dataset.img) stage.style.backgroundImage = `url('${it.dataset.img}')`;
    };
    items.forEach(it => {
      it.addEventListener('mouseenter', () => setActive(it));
      it.addEventListener('focusin', () => setActive(it));
    });
    setActive(items[0]);
    /* Theme editor: selecting a ritual block shows its image in the stage */
    document.addEventListener('shopify:block:select', function (e) {
      var it = e.target && e.target.closest ? e.target.closest('.air2__item') : null;
      if (it) setActive(it);
    });
  })();

  /* Portraits rail — manual scroll with left/right arrows */
  (() => {
    const rail = document.getElementById('portRail');
    if (!rail) return;
    const prev = document.querySelector('.port__nav--prev');
    const next = document.querySelector('.port__nav--next');
    const step = () => {
      const card = rail.querySelector('.pcard');
      if (!card) return 240;
      const gap = parseFloat(getComputedStyle(rail).gap) || 16;
      return card.getBoundingClientRect().width + gap;
    };
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left:  step() * 2, behavior: 'smooth' }));
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth - 4;
      if (prev) prev.style.opacity = rail.scrollLeft <= 4 ? '0' : '1';
      if (next) next.style.opacity = rail.scrollLeft >= max ? '0' : '1';
      if (prev) prev.style.pointerEvents = rail.scrollLeft <= 4 ? 'none' : 'auto';
      if (next) next.style.pointerEvents = rail.scrollLeft >= max ? 'none' : 'auto';
    };
    rail.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  })();

  const heroEl = document.querySelector('.hero');

  /* reduced motion → show everything, skip the show */
  if (reduce) {
    document.querySelectorAll('.reveal, .reveal-l').forEach(e => e.classList.add('in'));
    heroEl.classList.add('hero-ready');
    return;
  }

  /* ============================================================
     LENIS — buttery smooth scroll (synced to GSAP's ticker)
     ============================================================ */
  let lenis = null;
  if (hasLenis) {
    lenis = new Lenis({ duration: 1.15, easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    window.lenisY = 0;
    lenis.on('scroll', (e) => { window.lenisY = e.animatedScroll || e.scroll || 0; onHead(); if (hasGSAP) ScrollTrigger.update(); });
    if (hasGSAP) {
      gsap.ticker.add(t => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
    } else {
      const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
  }

  /* Smooth-scroll in-page anchors — works for "#air" AND header links like "/#air",
     using Lenis when available, otherwise a native smooth scroll. */
  function smoothTo(target){
    if (lenis) { lenis.scrollTo(target, { offset: -70, duration: 1.4 }); return; }
    var top = target.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - 70;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0) return;
    var hash = href.slice(i);
    if (hash.length < 2) return;
    var path = href.slice(0, i);
    var samePage = (path === '' || path === location.pathname || (path === '/' && location.pathname === '/'));
    if (!samePage) return;
    var target;
    try { target = document.querySelector(hash); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    if (history.replaceState) { history.replaceState(null, '', hash); }
    smoothTo(target);
  }, false);

  /* ============================================================
     ANIME.JS — hero entrance choreography + nav drift-in
     ============================================================ */
  if (hasAnime) {
    anime.timeline({ easing: 'easeOutExpo' })
      .add({ targets: '.hero__whisper', opacity: [0, 1], translateY: [30, 0], duration: 1400 })
      .add({ targets: '.hero__tag',     opacity: [0, 1], translateY: [16, 0], duration: 900 }, '-=1000')
      .add({ targets: '.hero__sub',     opacity: [0, 1], translateY: [16, 0], duration: 900 }, '-=680')
      .add({ targets: '.hero__actions', opacity: [0, 1], translateY: [16, 0], duration: 900 }, '-=640')
      .add({ targets: '.hero__cue',     opacity: [0, 1], translateY: [10, 0], duration: 800 }, '-=560');
    /* desktop only — on a phone these links live inside the closed drawer,
       and fading invisible words only made the menu feel late.
       And only the words actually standing on the bar: the old selector
       staggered through ~15 links hidden inside the closed panels too,
       so the icons at the far end waited ~2.5s for their turn. */
    if (matchMedia('(min-width:1101px)').matches)
      anime({ targets: '#nav > a, #nav > .nav__util, #nav .nav__group > .nav__top',
              opacity: [0, 1], translateY: [-8, 0],
              delay: anime.stagger(60, { start: 140 }), duration: 550, easing: 'easeOutQuad' });
  } else {
    heroEl.classList.add('hero-ready');
  }

  /* ============================================================
     GSAP + SCROLLTRIGGER — reveals, parallax, the moving rail
     ============================================================ */
  if (hasGSAP) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({ nullTargetWarn: false });

    /* reveal: ScrollTrigger toggles .in, the CSS transition does the motion */
    ScrollTrigger.batch('.reveal, .reveal-l', {
      start: 'top 86%',
      once: true,
      onEnter: batch => batch.forEach((el, i) => { el.style.transitionDelay = (i * 90) + 'ms'; el.classList.add('in'); })
    });

    /* parallax on the full-bleed backgrounds (scrubbed) */
    gsap.utils.toArray('[data-parallax]').forEach(el => {
      const sp = parseFloat(el.dataset.parallax) || 0.12;
      gsap.set(el, { scale: 1.18, transformOrigin: 'center' });
      gsap.fromTo(el, { yPercent: -sp * 60 }, {
        yPercent: sp * 60, ease: 'none',
        scrollTrigger: { trigger: el.closest('section') || el, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
    /* parallax on framed images (moves within its rounded frame) */
    gsap.utils.toArray('[data-parallax-img]').forEach(el => {
      const sp = parseFloat(el.dataset.parallaxImg) || 0.08;
      gsap.fromTo(el, { yPercent: -sp * 100 }, {
        yPercent: sp * 100, ease: 'none',
        scrollTrigger: { trigger: el.closest('section') || el, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });

    addEventListener('load', () => ScrollTrigger.refresh());
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => ScrollTrigger.refresh());

  } else {
    /* ---- FALLBACK (no GSAP): direct scroll reveal + parallax, no rAF dependency ---- */
    const reveals = [...document.querySelectorAll('.reveal, .reveal-l')];
    const par = [...document.querySelectorAll('[data-parallax]')];
    const imgPar = [...document.querySelectorAll('[data-parallax-img]')];
    const check = () => {
      const vh = innerHeight;
      for (const el of reveals) { if (el.classList.contains('in')) continue; const r = el.getBoundingClientRect(); if (r.top < vh * 0.88 && r.bottom > 0) el.classList.add('in'); }
      for (const el of par) { const sp = parseFloat(el.dataset.parallax) || 0.12; const r = el.getBoundingClientRect(); const c = r.top + r.height / 2 - vh / 2; el.style.transform = `translate3d(0, ${(-c * sp).toFixed(1)}px, 0) scale(1.16)`; }
      for (const el of imgPar) { const sp = parseFloat(el.dataset.parallaxImg) || 0.08; const r = el.getBoundingClientRect(); const c = r.top + r.height / 2 - vh / 2; el.style.transform = `translate3d(0, ${(-c * sp).toFixed(1)}px, 0) scale(1.1)`; }
    };
    addEventListener('scroll', check, { passive:true });
    addEventListener('resize', check, { passive:true });
    addEventListener('load', check);
    check();
  }

  /* ---- safety net: if rAF-based animation never advances (e.g. a non-painting
     tab or a blocked library), force every element visible after a beat ---- */
  setTimeout(() => {
    const w = document.querySelector('.hero__whisper');
    if (w && getComputedStyle(w).opacity === '0') {
      heroEl.classList.add('hero-ready');
      document.querySelectorAll('.hero__whisper,.hero__tag,.hero__sub,.hero__actions,.hero__cue,.nav a')
        .forEach(e => { e.style.opacity = '1'; e.style.transform = 'none'; });
      document.querySelectorAll('.reveal, .reveal-l').forEach(e => e.classList.add('in'));
    }
  }, 2600);
});
